/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;

  var scanqr = function scanqr() {
    cordova.plugins.barcodeScanner.scan(function (result) {
      // alert("We got a barcode\n" +
      //       "Result: " + result.text + "\n" +
      //       "Format: " + result.format + "\n" +
      //       "Cancelled: " + result.cancelled);
      window.orderId = result.text;
      window.copy = true;
      window.origin = "agent_pay";
      $f7.views.current.router.navigate("/cashier_receipt/", {
        force: true
      });
    }, function (error) {
      alert("Scanning failed: " + error);
    });
  };

  var scandata = "";

  var search = function search() {
    window.orderId = $("#orderid").val();
    window.origin = "agent_pay";
    $("#orderid").val("");
    $f7.views.current.router.navigate("/cashier_receipt/", {
      force: true
    });
  };

  $on('pageAfterOut', function () {
    clearInterval(window.langPlace2);
  });
  $on('pageInit', function () {
    scandata = "";
    $('#orderid').blur();
    $("#orderid").on('keypress', function (e) {
      if (e.which == 13) {
        search();
      }
    });
    window.langPlace2 = setInterval(function () {
      if (window.lang == "tl") document.getElementById("orderid").placeholder = "Tama hameno id";
      if (window.lang == "en") document.getElementById("orderid").placeholder = "Enter your order id";
      if (window.lang == "cn") document.getElementById("orderid").placeholder = "输入您的订单编号";
    }, 1000); // $('body').on('keyup', function (event) {
    //   if($f7.views.current.name=="pay")
    //   {
    //     console.log("this is the current name" + $f7.views.current.name);
    //     var key = event.key;
    //     key = key.toUpperCase();
    //     if(key != "SHIFT" && key !="ENTER")
    //     scandata+=key;
    //     if(key == "ENTER")
    //     {
    //       window.orderId = scandata;
    //       scandata = "";
    //       $f7.views.current.router.navigate("/cashier_receipt/",{force:true});
    //     }
    //   }  
    // });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <!-- <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div> -->
      <div class="title">
        <span class='en'>Scan Receipt</span>
        <span class='cn'>扫描收据</span>
        <span class='tl'>Scan Resibu</span>
      </div>
    </div>
  </div>
  <div class="page-content">
    
    <div class="block" style="text-align: center;">
      <p>
        <span class='en'>Touch the scanner image below to scan the receipt or enter order id</span>
        <span class='cn'>触摸下方的扫描仪图像以扫描收据或输入订单编号</span>
        <span class='tl'>Kona scanner ka tama hameno ID</span>
      </p>
      <img src='static/images/scan.png' width='200px' @click=${scanqr}/>
      <br/>
        
          <span class='en'>OR</span>
          <span class='cn'>或者</span>
          <span class='tl'>KA</span>
        
      <br/>
      <div class="list no-hairlines-md">
        <ul  style="background-color: transparent">
          <li class="item-content item-input item-input-outline" >
            <div class="item-inner">
              <div class="item-title item-floating-label">
                <span class='en'>ORDER ID</span>
                <span class='cn'>订单编号</span>
                <span class='tl'>HAMENO ID</span>
              </div>
              <div class="item-input-wrap">
                <input type="text" id="orderid" placeholder="Key in receipt Order ID" />
                <span class="input-clear-button"></span>
                
              </div>
              <button class="button button-fill" @click=${search}>
                <span class='en'>SEARCH</span>
                <span class='cn'>搜索</span>
                <span class='tl'>BUKA</span>
              </button>
            </div>
          </li>
        </ul>
      </div>
      <div class="orderid">
      
      </div>
    </div>
  </div>
</div>
`
    }
    ;
}

framework7Component.id = 'd5c46ffd93';
export default framework7Component;